import { checkIfFeatureFlagsAreEnabled } from 'modules/workflows/utils';
import { EMAIL, EMBEDDED, IN_APP, SMS, PUSH, WEB_PUSH, WHATS_APP } from 'constants/messageMediums';

/** There are a couple of projects which have these disabled which is why we still need to check for these */
export const mediumFeatureFlag = {
  [`${SMS}`]: ['TemplateEditSMS'],
  [`${EMAIL}`]: ['TemplateEditEmail'],
  [`${PUSH}`]: ['TemplateEditPush'],
  [`${WEB_PUSH}`]: ['TemplateEditWebPush'],
  [`${IN_APP}`]: ['TemplateEditInApp'],
  [`${EMBEDDED}`]: ['EmbeddedMessagingCore'],
  [`${WHATS_APP}`]: ['WhatsAppMessageChannel', 'WhatsAppMessageChannelGA'],
};

export const isStudioTemplateEditingEnabled = (
  mediumType: string,
  featureFlags: Record<string, boolean>,
): boolean => checkIfFeatureFlagsAreEnabled(mediumFeatureFlag[mediumType], featureFlags, true);

export const checkIsSendEditorImprovementsEnabled = (
  mediumType: string,
  featureFlags: Record<string, boolean>,
): boolean =>
  mediumType === WHATS_APP
    ? !!featureFlags?.WhatsAppMessageChannel || !!featureFlags?.WhatsAppMessageChannelGA
    : !!featureFlags?.JourneySendEditorImprovements;
